"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactQuery = require("react-query");
var _reactI18next = require("react-i18next");
var _core = require("@material-ui/core");
var _lodash = require("lodash");
var _lab = require("@material-ui/lab");
var _styles = require("@material-ui/core/styles");
var _axios = _interopRequireDefault(require("axios"));
var _clsx = _interopRequireDefault(require("clsx"));
var _queryString = _interopRequireDefault(require("query-string"));
var _bookmarkIcon = _interopRequireDefault(require("../../components/bookmark-icon"));
var _elementHeadline = _interopRequireDefault(require("../../components/element-headline"));
var _menuFilter = _interopRequireDefault(require("../../components/menu-filter"));
var _searchField = _interopRequireDefault(require("../../components/search-field"));
var _uidrawer = _interopRequireDefault(require("../../components/uidrawer"));
var _pageContext = _interopRequireDefault(require("../../context/pageContext"));
var _userContext = _interopRequireDefault(require("../../context/userContext"));
var _image = _interopRequireDefault(require("../../helper/image"));
var _svgicon = _interopRequireDefault(require("../../helper/svgicon"));
var _changeLanguage = _interopRequireDefault(require("../../utils/changeLanguage"));
var _formatPrice = _interopRequireDefault(require("../../utils/formatPrice"));
var _resolveImage = _interopRequireDefault(require("../../utils/resolveImage"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    padding: "env(safe-area-inset-top) env(safe-area-inset-right) env(safe-area-inset-bottom) env(safe-area-inset-left)",
    position: "relative"
  },
  contentMarginBottom: {
    marginBottom: 75 + theme.spacing(4)
  },
  topWrapper: {
    alignItems: "center",
    display: "flex",
    flexWrap: "nowrap",
    justifyContent: "space-between"
  },
  searchWrapper: {
    width: "100%"
  },
  filterButton: {
    alignItems: "center",
    borderRadius: "50%",
    cursor: "pointer",
    display: "flex",
    height: 40,
    marginLeft: theme.spacing(2),
    minWidth: 40,
    padding: 0,
    width: 40
  },
  filterWrapper: {
    paddingBottom: "calc(env(safe-area-inset-bottom) + 90px)",
    paddingTop: theme.spacing(2.5)
  },
  tagWrapper: {
    flexWrap: "nowrap",
    overflow: "auto"
  },
  headline: {
    marginTop: theme.spacing(4)
  },
  mealWrapper: {
    flexWrap: "nowrap",
    justifyContent: "space-between",
    marginBottom: theme.spacing(1)
  },
  mealTitle: {
    fontWeight: 700
  },
  mealLeftWrapper: {
    display: "flex",
    marginRight: theme.spacing(2)
  },
  mealContentWrapper: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    justifyContent: "center"
  },
  mealRightWrapper: {
    alignItems: "center",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    marginLeft: theme.spacing(2),
    textAlign: "right"
  },
  mealPrice: {
    marginRight: theme.spacing(1),
    whiteSpace: "nowrap"
  },
  mealAllergens: {
    ...theme.customTypography.allergensLabel,
    marginLeft: theme.spacing(1)
  },
  mealImage: {
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
    marginLeft: theme.spacing(-2),
    marginRight: theme.spacing(-2),
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.spacing(-4),
      marginRight: theme.spacing(-4)
    },
    [theme.breakpoints.up("md")]: {
      marginLeft: theme.spacing(-3),
      marginRight: theme.spacing(-3)
    },
    [theme.breakpoints.up("lg")]: {
      marginLeft: 0,
      marginRight: 0
    }
  },
  quantityInput: {
    overflow: "hidden",
    width: 43,
    "& input[type=number]": {
      padding: theme.spacing(1.5, 1),
      textAlign: "center",
      "-moz-appearance": "textfield"
    },
    "& input::-webkit-outer-spin-button, input::-webkit-inner-spin-button": {
      "-webkit-appearance": "none",
      margin: 0
    }
  },
  formWrapper: {
    background: theme.palette.background.menuForm,
    bottom: "calc(env(safe-area-inset-bottom) + 75px)",
    height: 75,
    left: 0,
    position: "fixed",
    right: 0,
    zIndex: theme.zIndex.menuForm
  },
  formButtonWrapper: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      width: "auto"
    }
  },
  formButtonReset: {
    marginRight: theme.spacing(1.5)
  },
  formContent: {
    alignItems: "center",
    display: "flex",
    height: "100%",
    justifyContent: "space-between"
  },
  formQuantityWrapper: {
    display: "none",
    [theme.breakpoints.up("sm")]: {
      display: "block"
    }
  },
  formValue: {
    fontSize: 26,
    fontWeight: 700,
    marginRight: theme.spacing(1)
  }
}));
const FilterTags = _ref => {
  let {
    data,
    tags,
    onFilter
  } = _ref;
  const {
    items
  } = data;
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const css = useStyles();
  const handleClick = id => {
    let index = tags.findIndex(tag => tag === id);
    if (index === -1) {
      if (tags.length === items.length - 1) {
        onFilter({
          tags: []
        });
        return;
      }
      onFilter({
        tags: [...tags, id]
      });
      return;
    }
    onFilter({
      tags: tags.filter(tag => tag !== id)
    });
  };
  const handleClickAll = () => {
    onFilter({
      tags: []
    });
  };
  return /*#__PURE__*/_react.default.createElement(_core.Grid, {
    className: css.tagWrapper,
    container: true,
    spacing: 1
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true
  }, /*#__PURE__*/_react.default.createElement(_core.Chip, {
    className: css.tag,
    color: tags.length === 0 ? "primary" : "default",
    label: t("site.ui.labels.selectAll"),
    onClick: () => handleClickAll()
  })), items.map(item => {
    const {
      id,
      title
    } = item;
    return /*#__PURE__*/_react.default.createElement(_core.Grid, {
      key: id,
      item: true
    }, /*#__PURE__*/_react.default.createElement(_core.Chip, {
      className: css.tag,
      color: tags.includes(id) ? "primary" : "default",
      label: title,
      onClick: () => handleClick(id)
    }));
  }));
};
const MealImage = _ref2 => {
  var _subFormat, _subFormat2, _subFormat3, _subFormat4, _subFormat5;
  let {
    media
  } = _ref2;
  const {
    REACT_APP_PATH
  } = process.env;
  const css = useStyles();
  let subFormat = null;
  if (media !== null && media !== void 0 && media.subFormats) {
    subFormat = (0, _lodash.first)((0, _resolveImage.default)(media === null || media === void 0 ? void 0 : media.subFormats, "meal-large"));
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, ((_subFormat = subFormat) === null || _subFormat === void 0 ? void 0 : _subFormat.filename) && /*#__PURE__*/_react.default.createElement(_image.default, {
    itemStyle: css.image,
    filename: (((_subFormat2 = subFormat) === null || _subFormat2 === void 0 ? void 0 : _subFormat2.filename.charAt(0)) === "/" ? REACT_APP_PATH : "") + ((_subFormat3 = subFormat) === null || _subFormat3 === void 0 ? void 0 : _subFormat3.filename),
    height: (_subFormat4 = subFormat) === null || _subFormat4 === void 0 ? void 0 : _subFormat4.height,
    width: (_subFormat5 = subFormat) === null || _subFormat5 === void 0 ? void 0 : _subFormat5.width,
    alt: media === null || media === void 0 ? void 0 : media.alt
  }));
};
const MealVariants = _ref3 => {
  let {
    id: menuID,
    menu,
    objectType,
    title: menuTitle,
    variants,
    orderable,
    isCheckedIn,
    selected,
    onChange
  } = _ref3;
  const {
    i18n
  } = (0, _reactI18next.useTranslation)();
  const css = useStyles();
  const getItemByID = (id, variantID) => {
    return selected.find(item => item.id === id && item.variantID === variantID);
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, variants.map(_ref4 => {
    var _item$quantity;
    let {
      id,
      price,
      title
    } = _ref4;
    const item = getItemByID(menuID, id);
    return /*#__PURE__*/_react.default.createElement(_core.Grid, {
      key: "".concat(menuID, "-").concat(id),
      className: (0, _clsx.default)({
        [css.mealWrapper]: true
      }),
      container: true
    }, isCheckedIn && orderable && /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true,
      className: css.mealLeftWrapper
    }, /*#__PURE__*/_react.default.createElement(_core.TextField, {
      type: "number",
      variant: "outlined",
      InputProps: {
        className: css.quantityInput,
        inputProps: {
          min: 0,
          max: 99,
          placeholder: 0,
          value: (_item$quantity = item === null || item === void 0 ? void 0 : item.quantity) !== null && _item$quantity !== void 0 ? _item$quantity : ""
        }
      },
      onChange: event => {
        onChange(menuID, menuTitle, title, id, parseInt(event.target.value));
      }
    })), /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true,
      className: css.mealContentWrapper
    }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
      className: css.mealVariantTitle,
      component: "p"
    }, /*#__PURE__*/_react.default.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: title
      }
    }))), /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true,
      className: css.mealRightWrapper
    }, price && price !== "0" && /*#__PURE__*/_react.default.createElement(_core.Typography, {
      className: (0, _clsx.default)(css.mealPrice, "mco-meal-variants-item__price"),
      component: "p"
    }, (0, _formatPrice.default)(price, i18n.language)), /*#__PURE__*/_react.default.createElement(_bookmarkIcon.default, {
      id: "".concat(menuID, "-").concat(id),
      type: objectType,
      title: "".concat(menuTitle, " ").concat(title),
      addition: menu,
      link: "".concat(window.location.pathname, "#").concat(id),
      position: "relative"
    })));
  }));
};
const ListMeals = _ref5 => {
  let {
    data,
    menu,
    orderable = false,
    user,
    selected,
    onChange
  } = _ref5;
  const {
    i18n,
    t
  } = (0, _reactI18next.useTranslation)();
  const css = useStyles();
  let lastGroup = null;
  const getItemByID = (id, variantID) => {
    return selected.find(item => item.id === id && item.variantID === variantID);
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, data.length > 0 ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, data.map(_ref6 => {
    var _item$quantity2;
    let {
      id,
      allergens,
      description,
      groupTitle,
      objectType,
      price,
      title,
      top,
      media,
      variants
    } = _ref6;
    let headline = null;
    if (groupTitle !== lastGroup) {
      headline = /*#__PURE__*/_react.default.createElement(_core.Grid, {
        item: true,
        xs: 12,
        className: css.headline
      }, /*#__PURE__*/_react.default.createElement(_elementHeadline.default, {
        uppercase: true,
        title: groupTitle
      }));
      lastGroup = groupTitle;
    }
    const item = getItemByID(id, 0);
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
      key: id
    }, headline, /*#__PURE__*/_react.default.createElement(_core.Box, {
      key: id,
      my: 2
    }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
      className: (0, _clsx.default)({
        [css.mealWrapper]: true
      }),
      container: true
    }, (user === null || user === void 0 ? void 0 : user.onSite) && orderable && !variants && /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true,
      className: css.mealLeftWrapper
    }, /*#__PURE__*/_react.default.createElement(_core.TextField, {
      type: "number",
      variant: "outlined",
      InputProps: {
        className: css.quantityInput,
        inputProps: {
          min: 0,
          max: 99,
          placeholder: 0,
          value: (_item$quantity2 = item === null || item === void 0 ? void 0 : item.quantity) !== null && _item$quantity2 !== void 0 ? _item$quantity2 : ""
        }
      },
      onChange: event => {
        onChange(id, title, description, 0, parseInt(event.target.value));
      }
    })), /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true,
      className: css.mealContentWrapper
    }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
      className: css.mealTitle,
      component: "p"
    }, title, allergens && /*#__PURE__*/_react.default.createElement("span", {
      className: css.mealAllergens
    }, allergens)), description && /*#__PURE__*/_react.default.createElement(_core.Typography, {
      component: "p",
      dangerouslySetInnerHTML: {
        __html: description
      }
    })), /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true,
      className: css.mealRightWrapper
    }, price !== "0" && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.Typography, {
      className: (0, _clsx.default)(css.mealPrice, "mco-list-meal-item__price"),
      component: "p"
    }, (0, _formatPrice.default)(price, i18n.language)), /*#__PURE__*/_react.default.createElement(_bookmarkIcon.default, {
      id: id,
      type: objectType,
      title: title,
      addition: menu,
      link: "".concat(window.location.pathname, "#").concat(id),
      position: "relative"
    })))), variants && /*#__PURE__*/_react.default.createElement(MealVariants, {
      id: id,
      menu: menu,
      objectType: objectType,
      title: title,
      variants: variants,
      orderable: orderable,
      isCheckedIn: user === null || user === void 0 ? void 0 : user.onSite,
      selected: selected,
      onChange: onChange
    }), top && /*#__PURE__*/_react.default.createElement(_core.Box, {
      className: css.mealImage,
      key: id,
      my: 2
    }, /*#__PURE__*/_react.default.createElement(MealImage, {
      media: (0, _lodash.first)(media)
    }))));
  })) : /*#__PURE__*/_react.default.createElement(_lab.Alert, {
    severity: "error"
  }, t("site.ui.errors.noMeals")));
};
const getMenuByID = (menus, id) => {
  return menus === null || menus === void 0 ? void 0 : menus.filter(item => {
    return (item === null || item === void 0 ? void 0 : item.id) === parseInt(id);
  });
};
const LayoutMenu = _ref7 => {
  var _queryString$parse$pr, _queryString$parse, _filter$query$title, _filter$query, _details$data, _details$data2, _details$data3, _menuMeals$data, _first3, _details$data4, _details$data5;
  let {
    match,
    location
  } = _ref7;
  const {
    id,
    lang
  } = match.params;
  const {
    search
  } = location;
  const {
    REACT_APP_PATH,
    REACT_APP_PROVIDER_ID
  } = process.env;
  const [pageData, setPageData] = (0, _react.useContext)(_pageContext.default);
  const [providers] = (0, _react.useState)((_queryString$parse$pr = (_queryString$parse = _queryString.default.parse(search)) === null || _queryString$parse === void 0 ? void 0 : _queryString$parse.providers) !== null && _queryString$parse$pr !== void 0 ? _queryString$parse$pr : "");
  const [userData] = (0, _react.useContext)(_userContext.default);
  const [filter, setFilter] = (0, _react.useState)({
    allergens: [],
    groups: [],
    tags: [],
    query: {}
  });
  const [filterOpen, setFilterOpen] = (0, _react.useState)(false);
  const [formError, setFormError] = (0, _react.useState)(false);
  const [selected, setSelected] = (0, _react.useState)([]);
  const {
    i18n,
    t
  } = (0, _reactI18next.useTranslation)();
  const css = useStyles();
  (0, _react.useEffect)(() => {
    var _pageData$data, _first, _first2;
    if (!menuMealFilter || (pageData === null || pageData === void 0 || (_pageData$data = pageData.data) === null || _pageData$data === void 0 || (_pageData$data = _pageData$data.meta) === null || _pageData$data === void 0 ? void 0 : _pageData$data.title) === ((_first = (0, _lodash.first)(getMenuByID(menus === null || menus === void 0 ? void 0 : menus.data, id))) === null || _first === void 0 ? void 0 : _first.title)) {
      return;
    }
    const additionalPageData = {
      ...pageData
    };
    additionalPageData.data = {
      ...pageData.data,
      meta: {
        title: (_first2 = (0, _lodash.first)(getMenuByID(menus === null || menus === void 0 ? void 0 : menus.data, id))) === null || _first2 === void 0 ? void 0 : _first2.title
      }
    };
    setPageData(additionalPageData);
  });
  const url = "".concat(REACT_APP_PATH, "/Micado.Tourism.Web/Micado.Tourism.Web.IO.Api.ProviderApi/MenuDetails.api?menuID=").concat(id, "&lang=").concat(lang);
  const {
    data: details,
    status: statusDetails
  } = (0, _reactQuery.useQuery)(["menu-details", lang, id], () => _axios.default.get(url));
  const urlMenus = "".concat(REACT_APP_PATH, "/Micado.Tourism.Web/Micado.Tourism.Web.IO.Api.ProviderApi/ListMenus.api?providers=").concat(providers ? providers : REACT_APP_PROVIDER_ID, "&lang=").concat(lang);
  const {
    data: menus,
    status: statusMenus
  } = (0, _reactQuery.useQuery)(["list-menus", lang, providers], () => _axios.default.get(urlMenus));
  const urlMenuMealFilter = "".concat(REACT_APP_PATH, "/Micado.Tourism.Web/Micado.Tourism.Web.IO.Api.ProviderApi/ListMenuMealFilter.api?lang=").concat(lang, "&menuID=").concat(id);
  const {
    data: menuMealFilter,
    status: statusMenuMealFilter
  } = (0, _reactQuery.useQuery)(["list-menu-meal-filter", lang, id], () => _axios.default.get(urlMenuMealFilter));
  const urlMenuMeals = "".concat(REACT_APP_PATH, "/Micado.Tourism.Web/Micado.Tourism.Web.IO.Api.ProviderApi/ListMenuMeals.api?lang=").concat(lang, "&pageSize=99999&menuID=").concat(id, "&tags=").concat(filter === null || filter === void 0 ? void 0 : filter.tags, "&allergens=").concat(filter === null || filter === void 0 ? void 0 : filter.allergens, "&groups=").concat(filter === null || filter === void 0 ? void 0 : filter.groups, "&keyword=").concat((_filter$query$title = filter === null || filter === void 0 || (_filter$query = filter.query) === null || _filter$query === void 0 ? void 0 : _filter$query.title) !== null && _filter$query$title !== void 0 ? _filter$query$title : "", "&sort=1");
  const {
    data: menuMeals,
    status: statusMenuMeals
  } = (0, _reactQuery.useQuery)(["list-menu-meals", lang, id, filter], () => _axios.default.get(urlMenuMeals));
  if (statusDetails !== "success" || statusMenus !== "success" || statusMenuMealFilter !== "success" || statusMenuMeals !== "success") return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  if (lang !== i18n.language) {
    (0, _changeLanguage.default)(i18n, lang);
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  }
  const handleChange = (id, title, description, variantID, quantity) => {
    let index = selected.findIndex(item => item.id === id && item.variantID === variantID);
    if (index === -1 && quantity > 0) {
      setSelected([...selected, {
        id: id,
        title: title,
        description: description,
        variantID: variantID,
        quantity: quantity
      }]);
      return;
    }
    if (quantity === 0 || isNaN(quantity)) {
      let newSelected = [...selected];
      newSelected.splice(index, 1);
      setSelected(newSelected);
      return;
    }
    let changedSelected = selected.map(item => {
      if (item.id === id && item.variantID === variantID) {
        return {
          ...item,
          quantity: quantity
        };
      }
      return item;
    });
    setSelected(changedSelected);
  };
  const handleClose = () => {
    setFormError(!formError);
  };
  const handleClick = () => {
    setFilterOpen(!filterOpen);
  };
  const handleFilter = values => {
    setFilter({
      ...filter,
      ...values
    });
  };
  const handleReset = () => {
    setSelected([]);
  };
  const handleSearch = value => {
    setFilter({
      ...filter,
      query: value
    });
  };
  const handleSubmit = event => {
    event.preventDefault();
    const {
      REACT_APP_PATH,
      REACT_APP_ROOMSERVICE_RECEIVER
    } = process.env;
    const formData = new FormData(event.target);
    formData.append("layout", "mail");
    formData.append("lang", i18n.language);
    formData.append("receiver", REACT_APP_ROOMSERVICE_RECEIVER);
    formData.append("subject", "Roomservice");
    formData.append("redir", "/");
    formData.append("fields", "lastname=Nachname;roomnumber=Zimmernummer;order=Bestellung");
    fetch(REACT_APP_PATH + "/sendmail.api", {
      body: formData,
      method: "POST"
    }).then(response => {
      if (response.status === 200) {
        window.location.href = "/".concat(i18n.language, "/roomservice-success.html");
      } else {
        setFormError(true);
      }
    });
  };
  const getFormatedOrder = () => {
    let value = [];
    selected.forEach(item => {
      value.push("".concat(item.quantity, "x ").concat(item === null || item === void 0 ? void 0 : item.title).concat(item !== null && item !== void 0 && item.description ? " ".concat(item === null || item === void 0 ? void 0 : item.description) : ""));
    });
    return value.join("<br /><br />");
  };
  const getSelectedCounter = () => {
    let counter = 0;
    selected.forEach(item => {
      counter += item.quantity;
    });
    return counter;
  };
  const {
    tags
  } = menuMealFilter === null || menuMealFilter === void 0 ? void 0 : menuMealFilter.data;
  return /*#__PURE__*/_react.default.createElement(_core.Box, {
    my: 6
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    className: css.topWrapper,
    container: true
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    className: css.searchWrapper,
    item: true
  }, /*#__PURE__*/_react.default.createElement(_searchField.default, {
    placeholder: t("site.ui.search.placeholders.enterQuery"),
    value: filter === null || filter === void 0 ? void 0 : filter.query,
    onChange: handleSearch
  })), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true
  }, /*#__PURE__*/_react.default.createElement(_core.Button, {
    className: css.filterButton,
    variant: "contained",
    color: "primary",
    onClick: handleClick
  }, /*#__PURE__*/_react.default.createElement(_svgicon.default, {
    className: css.filterIcon,
    src: "/img/icons/customize.svg",
    size: 24
  })))), (tags === null || tags === void 0 ? void 0 : tags.items) && /*#__PURE__*/_react.default.createElement(_core.Box, {
    mb: 4,
    mt: 2
  }, /*#__PURE__*/_react.default.createElement(FilterTags, {
    data: tags,
    tags: filter === null || filter === void 0 ? void 0 : filter.tags,
    onFilter: handleFilter
  })), (details === null || details === void 0 || (_details$data = details.data) === null || _details$data === void 0 ? void 0 : _details$data.description) && /*#__PURE__*/_react.default.createElement(_core.Box, {
    my: 6
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    component: "p",
    dangerouslySetInnerHTML: {
      __html: details === null || details === void 0 || (_details$data2 = details.data) === null || _details$data2 === void 0 ? void 0 : _details$data2.description
    }
  })), /*#__PURE__*/_react.default.createElement(_core.Box, {
    className: (0, _clsx.default)({
      [css.contentMarginBottom]: (userData === null || userData === void 0 ? void 0 : userData.onSite) && (details === null || details === void 0 || (_details$data3 = details.data) === null || _details$data3 === void 0 ? void 0 : _details$data3.orderable) && !!selected.length
    }),
    my: 6
  }, /*#__PURE__*/_react.default.createElement(ListMeals, {
    data: menuMeals === null || menuMeals === void 0 || (_menuMeals$data = menuMeals.data) === null || _menuMeals$data === void 0 ? void 0 : _menuMeals$data.items,
    menu: (_first3 = (0, _lodash.first)(getMenuByID(menus === null || menus === void 0 ? void 0 : menus.data, id))) === null || _first3 === void 0 ? void 0 : _first3.title,
    orderable: details === null || details === void 0 || (_details$data4 = details.data) === null || _details$data4 === void 0 ? void 0 : _details$data4.orderable,
    selected: selected,
    user: userData,
    onChange: (id, title, description, variantID, quantity) => handleChange(id, title, description, variantID, quantity),
    onSubmit: event => handleSubmit(event)
  }), (userData === null || userData === void 0 ? void 0 : userData.onSite) && (details === null || details === void 0 || (_details$data5 = details.data) === null || _details$data5 === void 0 ? void 0 : _details$data5.orderable) && !!selected.length && /*#__PURE__*/_react.default.createElement("form", {
    className: css.formWrapper,
    method: "GET",
    onSubmit: event => handleSubmit(event)
  }, /*#__PURE__*/_react.default.createElement("input", {
    type: "hidden",
    name: "lastname",
    value: userData === null || userData === void 0 ? void 0 : userData.lastname
  }), /*#__PURE__*/_react.default.createElement("input", {
    type: "hidden",
    name: "roomnumber",
    value: userData === null || userData === void 0 ? void 0 : userData.roomNumber
  }), /*#__PURE__*/_react.default.createElement("input", {
    type: "hidden",
    name: "order",
    value: getFormatedOrder()
  }), /*#__PURE__*/_react.default.createElement(_core.Container, {
    className: css.formContent
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: css.formQuantityWrapper
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: css.formValue
  }, getSelectedCounter()), /*#__PURE__*/_react.default.createElement("span", null, t("site.ui.labels.selected"))), /*#__PURE__*/_react.default.createElement("div", {
    className: css.formButtonWrapper
  }, /*#__PURE__*/_react.default.createElement(_core.Button, {
    className: css.formButtonReset,
    color: "primary",
    onClick: () => {
      handleReset();
    }
  }, t("site.ui.buttons.reset")), /*#__PURE__*/_react.default.createElement(_core.Button, {
    variant: "contained",
    color: "primary",
    type: "submit"
  }, t("site.ui.buttons.orderNow")))))), /*#__PURE__*/_react.default.createElement(_core.Snackbar, {
    open: formError,
    autoHideDuration: 6000,
    onClose: handleClose
  }, /*#__PURE__*/_react.default.createElement(_lab.Alert, {
    onClose: handleClose,
    severity: "error"
  }, t("site.ui.errors.roomServiceSend"))), /*#__PURE__*/_react.default.createElement(_uidrawer.default, {
    bottom: false,
    open: filterOpen,
    setMenuOpen: setFilterOpen,
    title: t("site.ui.pagetitles.filter")
  }, /*#__PURE__*/_react.default.createElement(_core.Container, {
    className: css.filterWrapper
  }, /*#__PURE__*/_react.default.createElement(_menuFilter.default, {
    data: filter,
    id: id,
    onFilter: handleFilter,
    onSearch: handleSearch,
    onFilterOpen: handleClick
  }))));
};
var _default = exports.default = LayoutMenu;